module.exports = __webpack_public_path__ + "static/img/download-center1.90beeb06.svg";